<fc-spinner [show]="false" name="user-spinner" [overlay]="true"></fc-spinner>
<fc-spinner [show]="false" name="site-spinner" [overlay]="true"></fc-spinner>
<div class="container">
  <div class="page-container">
    <div class="page-title">Stats Dashboard</div>
    <mat-expansion-panel expanded="true">
      <mat-expansion-panel-header>
        <h2>Valuation Summary</h2>
      </mat-expansion-panel-header>
      <div class="filter-section">
        <mat-form-field>
          <mat-label>Filter By Status:</mat-label>
          <mat-select
            (selectionChange)="applyStatusFilter($event, 'status')"
            [(value)]="filterStatusState"
            class="select-filter"
            multiple
            panelClass="status-panel"
            placeholder="Filter">
            <mat-option *ngFor="let status of sortStatusArray" [value]="status">
              {{ status }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <div>
          <mat-form-field>
            <mat-label>Filter By Region:</mat-label>
            <mat-select
              (selectionChange)="applyRegionFilter($event, 'valuationSummary')"
              [(value)]="filterRegionState['valuationSummary']"
              class="select-filter"
              multiple
              panelClass="status-panel"
              placeholder="Filter">
              <mat-option *ngFor="let region of allRegions" [value]="region.id">
                {{ region.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="title-bar">
        <div class="acres-container">
          <div class="top">{{ siteStats.total }}</div>
          <div class="divider"></div>
          <div class="bottom">Total Sites</div>
        </div>
        <div class="acres-container">
          <div class="top">
            {{
              siteStats.totalAcres.toLocaleString(undefined, {
                maximumFractionDigits: 2
              })
            }}
          </div>
          <div class="divider"></div>
          <div class="bottom">Total Acres</div>
        </div>
        <div class="acres-container">
          <div class="top">
            {{ formatService.formatFourDigits(siteStats.netErt) }}
          </div>
          <div class="divider"></div>
          <div class="bottom">NET ERT</div>
        </div>
        <div class="acres-container">
          <div class="top">
            {{ formatService.formatFourDigits(siteStats.ertPerAcre) }}
          </div>
          <div class="divider"></div>
          <div class="bottom">ERT / Acre</div>
        </div>
        <div class="acres-container">
          <div class="top">
            {{
              siteStats.acresPerSite.toLocaleString(undefined, {
                maximumFractionDigits: 2
              })
            }}
          </div>
          <div class="divider"></div>
          <div class="bottom">Acres / Site</div>
        </div>
        <div class="acres-container">
          <div class="top">
            {{ siteStats.averageAnnual | currency: 'USD' }}
          </div>
          <div class="divider"></div>
          <div class="bottom">Total Avg. Annual Payment</div>
        </div>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <h2>{{ totalCounts['Users'] }} Users</h2>
      </mat-expansion-panel-header>
      <mat-tab-group class="landowner-tabs">
        <mat-tab>
          <ng-template mat-tab-label>{{ totalCounts['Landowners'] }} Landowners</ng-template>
          <div class="multi-chart">
            <div class="sub-chart">
              <h2>By Status</h2>
              <div class="admin-chart">
                <ngx-charts-bar-vertical
                  scheme="forest"
                  noBarWhenZero="true"
                  [showGridLines]="false"
                  wrapTicks="true"
                  [trimXAxisTicks]="false"
                  showDataLabel="true"
                  xAxis="true"
                  [results]="userStatusData"></ngx-charts-bar-vertical>
              </div>
            </div>
            <div class="sub-chart">
              <h2>By Buyer</h2>
              <div class="admin-chart">
                <fc-custom-pie-chart [results]="userBuyerData"></fc-custom-pie-chart>
              </div>
            </div>
          </div>
        </mat-tab>
        <mat-tab>
          <ng-template mat-tab-label>{{ totalCounts['Admins'] }} Admins</ng-template>
          <div class="admin-chart">
            <fc-custom-pie-chart [results]="adminTypeData"></fc-custom-pie-chart>
          </div>
        </mat-tab>
      </mat-tab-group>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <h2>{{ totalCounts['Sites'] }} Sites</h2>
      </mat-expansion-panel-header>

      <div class="section-title">Filter By Region:</div>
      <mat-form-field>
        <mat-select
          (selectionChange)="applyRegionFilter($event, 'siteSummary')"
          [(value)]="filterRegionState['siteSummary']"
          class="select-filter"
          multiple
          panelClass="status-panel"
          placeholder="Filter">
          <mat-option *ngFor="let region of allRegions" [value]="region.id">
            {{ region.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <div class="multi-chart">
        <div class="main-chart">
          <div class="admin-chart">
            <fc-custom-pie-chart
              (select)="onSelect($event, siteTabGroup)"
              [results]="overallSiteData"></fc-custom-pie-chart>
          </div>
        </div>
        <div class="drill-down-chart">
          <mat-tab-group class="landowner-tabs" #siteTabGroup>
            <mat-tab label="Pending">
              <ng-template mat-tab-label>
                {{ totalCounts['Pending'] }} Pending
                <fa-icon
                  [icon]="['far', 'circle-info']"
                  class="blue"
                  matTooltip="Pending -- a site that is still being worked on by a landowner and is NOT submitted."
                  matTooltipClass="fc-tooltip"
                  matTooltipPosition="right"></fa-icon>
              </ng-template>
              <div class="admin-chart">
                <ngx-charts-bar-vertical
                  scheme="forest"
                  noBarWhenZero="true"
                  [showGridLines]="false"
                  wrapTicks="true"
                  [trimXAxisTicks]="false"
                  showDataLabel="true"
                  xAxis="true"
                  [results]="pendingSiteData"></ngx-charts-bar-vertical>
              </div>
            </mat-tab>
            <mat-tab label="Submitted">
              <ng-template mat-tab-label>
                {{ totalCounts['Submitted'] }} Submitted
                <fa-icon
                  [icon]="['far', 'circle-info']"
                  class="blue"
                  matTooltip="Submitted - a site that is undergoing internal review or contracting."
                  matTooltipClass="fc-tooltip"
                  matTooltipPosition="right"></fa-icon>
              </ng-template>
              <div class="admin-chart">
                <fc-custom-pie-chart [results]="submittedSiteData"></fc-custom-pie-chart>
              </div>
            </mat-tab>
            <mat-tab label="Active">
              <ng-template mat-tab-label>
                {{ totalCounts['Active'] }} Active
                <fa-icon
                  [icon]="['far', 'circle-info']"
                  class="blue"
                  matTooltip="Active - a site that has fully executed contract."
                  matTooltipClass="fc-tooltip"
                  matTooltipPosition="right"></fa-icon>
              </ng-template>
              <div class="admin-chart">
                <fc-custom-pie-chart [results]="activeSiteData"></fc-custom-pie-chart>
              </div>
            </mat-tab>
            <mat-tab label="Inactive">
              <ng-template mat-tab-label>
                {{ totalCounts['Inactive'] }} Inactive
                <fa-icon
                  [icon]="['far', 'circle-info']"
                  class="blue"
                  matTooltip="Inactive - a site that is Terminated or Contract rejected."
                  matTooltipClass="fc-tooltip"
                  matTooltipPosition="right"></fa-icon>
              </ng-template>
              <div class="admin-chart">
                <fc-custom-pie-chart [results]="inactiveSiteData"></fc-custom-pie-chart>
              </div>
            </mat-tab>
          </mat-tab-group>
        </div>
      </div>
    </mat-expansion-panel>
  </div>
</div>
